import {get, post, postJson, put, deleteApiJson} from '../axios'

const RESOURCE_BASE_PATH = '/member/level/list';

/***
 * 查询会员等级积分设置
 * @param p
 */
export const querymemberLevels= p => get(`${RESOURCE_BASE_PATH}` ,p)





